import { render, staticRenderFns } from "./ScoresFilter.vue?vue&type=template&id=539d5ea8"
import script from "./ScoresFilter.vue?vue&type=script&lang=js"
export * from "./ScoresFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports